import React, { useEffect, useState } from 'react';
import Breadcumb from '../Layouts/Breadcumb';
import { Grid } from '@mui/material';
import axios from 'axios';
import { Constants } from '../endPoints';

export default function Silverprice() {
  const [silverPrices, setSilverPrices] = useState([]);
  const [platinumPrices, setPlatinumPrices] = useState([]);

  useEffect(() => {
    fetchSilverPrices();
    fetchPlatinumPrices();
  }, []);

  const fetchSilverPrices = async () => {
    try {
      const response = await axios.get(Constants.listSilverPrices);
      if (response.data.status === 1) {
        setSilverPrices(response.data.data);
      } else {
        console.error("Failed to load silver prices");
      }
    } catch (error) {
      console.error("Error fetching silver prices:", error);
    }
  };

  const fetchPlatinumPrices = async () => {
    try {
      const response = await axios.get(Constants.listPlatinumPrices);
      if (response.data.status === 1) {
        setPlatinumPrices(response.data.data);
      } else {
        console.error("Failed to load platinum prices");
      }
    } catch (error) {
      console.error("Error fetching platinum prices:", error);
    }
  };

  return (
    <>
      <Breadcumb pagetitle="Silver Price" />
      <section className='py-12'>
        <div className='container mx-auto px-4'>
          <h2 className="text-3xl font-bold headningfont mb-10 text-center">
            Silver Prices Per Today in USD
          </h2>

          <Grid container spacing={1} className='justify-center'>
            <Grid item lg={7}>
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr>
                    <th className="px-6 py-3 border-b text-left text-sm font-bold bg-[#FBF8F1]">Silver</th>
                    <th className="px-6 py-3 border-b text-left text-sm font-bold bg-[#FBF8F1]">Price Today only</th>
                    <th className="px-6 py-3 border-b text-left text-sm font-bold bg-[#FBF8F1]">Market</th>
                  </tr>
                </thead>
                <tbody>
                  {silverPrices.length > 0 ? silverPrices.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-100">
                      <td className="px-6 py-4 border-b text-sm">{item.title}</td>
                      <td className="px-6 py-4 border-b text-sm">${parseFloat(item.price).toFixed(2)}</td>
                      <td className="px-6 py-4 border-b text-sm">{item.market}</td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4 text-sm text-gray-500">No silver price data available.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Grid>
          </Grid>

          <h2 className="text-3xl font-bold headningfont mb-10 text-center mt-10">
            Platinum Prices Per Today in USD
          </h2>

          <Grid container spacing={1} className='justify-center'>
            <Grid item lg={7}>
              <table className="min-w-full bg-white border border-gray-200">
                <thead>
                  <tr>
                    <th className="px-6 py-3 border-b text-left text-sm font-bold bg-[#FBF8F1]">Platinum</th>
                    <th className="px-6 py-3 border-b text-left text-sm font-bold bg-[#FBF8F1]">Price Today only</th>
                    <th className="px-6 py-3 border-b text-left text-sm font-bold bg-[#FBF8F1]">Market</th>
                  </tr>
                </thead>
                <tbody>
                  {platinumPrices.length > 0 ? platinumPrices.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-100">
                      <td className="px-6 py-4 border-b text-sm">{item.title}</td>
                      <td className="px-6 py-4 border-b text-sm">${parseFloat(item.price).toFixed(2)}</td>
                      <td className="px-6 py-4 border-b text-sm">{item.market}</td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4 text-sm text-gray-500">No platinum price data available.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
}
